import React, { useEffect, useState, startTransition } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Box from "@mui/material/Box";
import {
  Tooltip,
  Typography,
  Card,
  Avatar,
  TextField,
  Modal,
} from "@mui/material";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import "react-quill/dist/quill.snow.css";
import ReactQuill from "react-quill";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  postEngagementTemplate,
  getEngagementTemplate,
  deleteEngagementTemplate,
  templateVisitHistoryUpdate,
} from "./Network_Call";
import EditIcon from "@mui/icons-material/Edit";
import Navbar from "../Navbar/Navbar";
import { Container } from "@mui/system";
import Footer from "../Footer/Footer";
import { useParams, useNavigate } from "react-router-dom";
import { Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";

function ManageEngagementTemplate() {
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [richText, setRichText] = useState("");
  const [editText, setEditText] = useState("");
  const [templateName, setTemplateName] = useState("");
  const [description, setDescription] = useState("");
  const [editTemplateName, setEditTemplateName] = useState("");
  const [editDescription, setEditDescription] = useState("");
  const [engageId, setEngageId] = useState("");
  const [savedTemplates, setSavedTemplates] = useState([]);
  const [templateToView, setTemplateToView] = useState(null);
  const [copiedStatus, setCopiedStatus] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const impl_id = localStorage.getItem("tag_id");
  const navigate = useNavigate();
  const { journey_type } = useParams();

  const external_id = null;

  const handleOpenAddDialog = () => setOpenAddDialog(true);
  const handleCloseAddDialog = () => {
    setRichText("");
    setOpenAddDialog(false);
  };

  const handleTemplateClick = async (templateId, external_id) => {

    console.log("templateID", templateId);
    try {
      const response = await templateVisitHistoryUpdate(templateId, external_id);
      console.log("templateID", response);
  
      if (response.status === 200) {
        // Increment the views count locally
        setSavedTemplates((prevTemplates) =>
          prevTemplates.map((template) =>
            template.id === templateId
              ? { ...template, view_count: (template.view_count || 0) + 1 }
              : template
          )
        );
      }
    } catch (error) {
      console.error("Error updating template views: ", error);
      toast.error("Failed to update template views.");
    }
  };

  const handleOpenEditDialog = (template) => {
    console.log("temmmplate from open edit", template);
    const updatedTemplates = [...savedTemplates];
    setSavedTemplates(updatedTemplates);
    setTemplateToView(template);
    setEngageId(template.id);
    setEditTemplateName(template.template_name);
    setEditDescription(template.description);
    setEditText(template.template);
    setOpenEditDialog(true);
  };

  const handleCloseEditDialog = () => {
    setEditText("");
    setOpenEditDialog(false);
    setTemplateToView(null);
    setOpenEditDialog(false);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { day: "numeric", month: "short", year: "numeric" };
    const formattedDate = date.toLocaleDateString("en-GB", options);

    const now = new Date();
    const seconds = Math.floor((now - date) / 1000);

    let timeAgo;
    if (seconds < 60) {
      timeAgo = `${seconds} second${seconds === 1 ? "" : "s"} ago`;
    } else if (seconds < 3600) {
      const minutes = Math.floor(seconds / 60);
      timeAgo = `${minutes} minute${minutes === 1 ? "" : "s"} ago`;
    } else if (seconds < 86400) {
      const hours = Math.floor(seconds / 3600);
      timeAgo = `${hours} hour${hours === 1 ? "" : "s"} ago`;
    } else if (seconds < 2592000) {
      const days = Math.floor(seconds / 86400);
      timeAgo = `${days} day${days === 1 ? "" : "s"} ago`;
    } else if (seconds < 31536000) {
      const months = Math.floor(seconds / 2592000);
      timeAgo = `${months} month${months === 1 ? "" : "s"} ago`;
    } else {
      const years = Math.floor(seconds / 31536000);
      timeAgo = `${years} year${years === 1 ? "" : "s"} ago`;
    }
    return `${timeAgo}`;
  };

  const getEngagementTemplates = async () => {
    const external_id = null;
    const result = await getEngagementTemplate(impl_id, external_id);
    console.log("ddddddddddddddddd", result.data);
    if (result.status === 200) {
      setSavedTemplates(result.data.data);
    } else {
      console.log("Error in Getting Engagement Template ");
    }
  };

  useEffect(() => {
    getEngagementTemplates();
  }, []);

  console.log("tenmplateeeeeeeeee from engagement template", templateToView);

  const handleSave = async () => {
    if (richText.trim() || editText.trim()) {
      console.log("Ssssssssssssssssssssssssssssssssssssssssssssssssss");

      const isEditing = openEditDialog && templateToView;

      const text = isEditing ? editText : richText;
      const name = isEditing ? editTemplateName : templateName;
      const Template_description = isEditing ? editDescription : description;

      const Engage_id = isEditing ? engageId : null;

      console.log("temammamaplate id", engageId, Engage_id);

      try {
        const response = await postEngagementTemplate(
          impl_id,
          text,
          Engage_id,
          name,
          Template_description
        );
        console.log("postttt tagsss", response);

        if (response.status === 200) {
          toast.success("Template saved successfully!");

          if (isEditing) {
            const updatedTemplates = savedTemplates.map((template) =>
              template.id === response.data.data[0].id
                ? { ...template, template: text }
                : template
            );
            setSavedTemplates(updatedTemplates);
          } else {
            setSavedTemplates([...savedTemplates, response.data.data[0]]);
          }
          setRichText("");
          setEditText("");
          setTemplateName("");
          setEditTemplateName("");
          setDescription("");
          setEditDescription("");
          setTemplateToView(null);
          isEditing ? handleCloseEditDialog() : handleCloseAddDialog();
        } else {
          toast.error("Failed to save the template. Please try again.");
        }
      } catch (error) {
        console.error("Error saving template:", error);
        toast.error("An error occurred while saving the template.");
      }
    }
  };

  const handleReset = () => {
    setTemplateName("");
    setDescription("");
    setRichText("");
  };

  const handleDelete = async () => {
    console.log("delete id ", engageId);
    try {
      const response = await deleteEngagementTemplate(engageId);
      console.log("delete tagsss", response);

      if (response.status === 200) {
        setSavedTemplates((prevTemplates) =>
          prevTemplates.filter((template) => template.id !== engageId)
        );
        toast.success("Template deleted successfully!");
        handleCloseEditDialog();
      } else {
        toast.error("Failed to delete the template. Please try again.");
      }
    } catch (error) {
      console.error("Error deleting template:", error);
      toast.error("An error occurred while deleting the template.");
    }
  };

  const handleCopy = async (templateId, htmlContent) => {
    try {
      await navigator.clipboard.write([
        new ClipboardItem({
          "text/html": new Blob([htmlContent], { type: "text/html" }),
        }),
      ]);

      setCopiedStatus((prevStatus) => ({
        ...prevStatus,
        [templateId]: true,
      }));

      setTimeout(() => {
        setCopiedStatus((prevStatus) => ({
          ...prevStatus,
          [templateId]: false,
        }));
      }, 2000);

      handleTemplateClick(templateId, external_id);

    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };

  const handleGoBack = () => {
    startTransition(() => {
      navigate("/user/findcontact/" + journey_type);
    });
  };

  console.log("savedddddd", savedTemplates);
  console.log("temmm", templateToView);
  console.log("selected", selectedTemplate);

  const openTemplateModal = (template) => {
    console.log("temmmmmmplate", template);
    setSelectedTemplate(template);
    setOpenModal(true);
  };

  const closeModal = () => {
    setOpenModal(false);
    setSelectedTemplate(null);
  };

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event, template) => {
    setAnchorEl(event.currentTarget);
    setSelectedTemplate(template);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <ToastContainer />
      <Navbar />
      <Container>
        <Button
          variant="contained"
          color="primary"
          onClick={handleGoBack}
          startIcon={<ArrowBackIcon />}
          sx={{
            marginTop: "1rem",
          }}
        >
          Back
        </Button>

        <div style={{ marginTop: "2rem", marginBottom: "2rem" }}>
          {/* Add Template Button */}
          <Button
            style={{
              backgroundColor: "#838194",
              color: "#FFFFFF",
              marginBottom: "20px",
              fontSize: "13px",
            }}
            onClick={handleOpenAddDialog}
          >
            Add Template +
          </Button>

          {/* Displaying Templates */}

          <div style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem" }}>
            {savedTemplates.map((template) => (
              <div
                key={template.id}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  flexBasis: "100%",
                  maxWidth: "30%",
                }}
              >
                <Card
                  sx={{
                    padding: "20px",
                    boxShadow: "0 5px 10px rgba(0, 0, 0, 0.15)",
                    borderRadius: "12px",
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    border: "1px solid #00A0B2",
                    "&:hover": {
                      transform: "translateY(-5px)",
                      boxShadow: "0 6px 12px rgba(0, 0, 0, 0.2)",
                    },
                    width: "100%",
                  }}
                >
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        marginBottom: "10px",
                        wordBreak: "break-word",
                        width: "90%",
                        fontSize: { xs: "1rem", sm: "1.25rem", md: "1.5rem" },
                      }}
                    >
                      {template.template_name}
                    </Typography>
                    <div style={{ width: "10%" }}>
                      {/* 3 dots menu */}
                      <IconButton
                        sx={{ color: "#00A0B2" }}
                        onClick={(event) => handleClick(event, template)}
                      >
                        <MoreVertIcon />
                      </IconButton>
                    </div>
                  </div>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    sx={{ marginBottom: "15px" }}
                  >
                    {template.description}
                  </Typography>
                </Card>

                {/* Menu with Edit and View options */}
                <Menu
                  anchorEl={anchorEl}
                  open={
                    Boolean(anchorEl) && selectedTemplate?.id === template.id
                  }
                  onClose={handleClose}
                  sx={{ marginLeft: "2rem" }}
                >
                  <MenuItem
                    onClick={() => {
                      handleOpenEditDialog(template);
                      handleClose();
                    }}
                  >
                    Edit
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      openTemplateModal(template);
                      handleClose();
                    }}
                  >
                    View
                  </MenuItem>
                </Menu>

                {/* Updated info */}
                <Box
                  sx={{
                    textAlign: "right",
                    marginTop: "10px",
                    display: "flex",
                    justifyContent: "space-between",
                    margin: "0.5rem",
                  }}
                >
                  <Typography variant="caption" color="textSecondary">
                    Uses{" "}
                    <span style={{ fontWeight: "bolder" }}>
                      {template.view_count} times
                    </span>
                  </Typography>

                  <Typography variant="caption" color="textSecondary">
                    Updated{" "}
                    <span style={{ fontWeight: "bolder" }}>
                      {formatDate(template.last_updated_at)}
                    </span>
                  </Typography>
                </Box>
              </div>
            ))}
          </div>

          {/* View Templates */}
          <Modal open={openModal} onClose={closeModal}>
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: { xs: "90%", sm: "70%", md: "50%" },
                bgcolor: "background.paper",
                boxShadow: 24,
                p: 4,
                borderRadius: "10px",
              }}
            >
              {selectedTemplate && (
                <>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginBottom: "1rem",
                    }}
                  >
                    <Typography variant="h5">
                      {selectedTemplate.template_name}
                    </Typography>
                    <IconButton onClick={closeModal}>
                      <CloseIcon />
                    </IconButton>
                  </Box>
                  <Box
                    sx={{
                      backgroundColor: "#f5f5f5",
                      padding: "10px",
                      borderRadius: "10px",
                      marginBottom: "20px",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: selectedTemplate.template,
                    }}
                  />
                  <div style={{ textAlign: "right" }}>
                    <Button
                      onClick={() =>
                        handleCopy(
                          selectedTemplate.id,
                          selectedTemplate.template
                        )
                      }
                      startIcon={
                        copiedStatus[selectedTemplate.id] ? (
                          <CheckIcon />
                        ) : (
                          <ContentCopyIcon />
                        )
                      }
                    >
                      {copiedStatus[selectedTemplate.id] ? "Copied" : "Copy"}
                    </Button>
                  </div>
                </>
              )}
            </Box>
          </Modal>

          {/* Add Template Dialog */}
          <Dialog
            open={openAddDialog}
            onClose={handleCloseAddDialog}
            maxWidth="xs"
            fullWidth
          >
            <DialogTitle>
              Email Template
              <IconButton
                onClick={handleCloseAddDialog}
                sx={{
                  position: "absolute",
                  top: "5px",
                  right: "5px",
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              <TextField
                label="Template Name"
                variant="outlined"
                fullWidth
                margin="normal"
                value={templateName}
                onChange={(e) => setTemplateName(e.target.value)}
                placeholder="Enter template name"
              />

              <TextField
                label="Description"
                variant="outlined"
                fullWidth
                margin="normal"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Enter description (optional)"
                multiline
                rows={4}
              />

              <ReactQuill
                value={richText}
                onChange={setRichText}
                placeholder="Write your email content here..."
                style={{
                  height: "150px",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  margin: "0",
                  padding: "0",
                  overflow: "hidden",
                }}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleSave} variant="contained">
                Create Template
              </Button>
              <Button onClick={handleReset} variant="contained" color="error">
                Reset
              </Button>
            </DialogActions>
          </Dialog>

          {/* Edit Template Dialog */}
          <Dialog
            open={openEditDialog}
            onClose={handleCloseEditDialog}
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle>
              View Template
              <IconButton
                onClick={handleCloseEditDialog}
                sx={{
                  position: "absolute",
                  top: "5px",
                  right: "5px",
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              <>
                <TextField
                  label="Template Name"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  value={editTemplateName}
                  onChange={(e) => setEditTemplateName(e.target.value)}
                  placeholder="Enter template name"
                />

                <TextField
                  label="Description"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  value={editDescription}
                  onChange={(e) => setEditDescription(e.target.value)}
                  placeholder="Enter description"
                  multiline
                  rows={4}
                />

                <ReactQuill
                  value={editText}
                  onChange={(value) => setEditText(value)}
                  style={{
                    height: "150px",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    margin: "0",
                    padding: "0",
                    overflow: "hidden",
                  }}
                />
              </>
            </DialogContent>

            <DialogActions>
              <Button onClick={handleSave} variant="contained">
                Edit Template
              </Button>
              <Button onClick={handleDelete} variant="contained" color="error">
                Delete
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </Container>
      <Footer />
    </>
  );
}

export default ManageEngagementTemplate;
